<template>
	<view class="content">
    <view class="top-bg">
        <p class="title">粤港澳物流智慧园区</p>
        <p>欢迎您</p>
    </view>
    <view class="main">
      <u-grid @click="click" :border="true" col="2">
        <u-grid-item
            v-for="(item,baseListIndex) in baseList"
            :key="baseListIndex"
        >
          <view class="grid-item">
            <u-icon :customStyle="{paddingTop:20+'rpx'}" :name="item.name" :size="32"></u-icon>
            <text class="grid-text">{{item.title}}</text>
          </view>
        </u-grid-item>
      </u-grid>
      <u-gap height="10" bgColor="#e7e8ed"></u-gap>
      <view style="padding: 20px">
        <view class="disflex">
          <u-icon name="warning-fill" :size="28" color="#e63c20"></u-icon>智慧园区安全注意事项
        </view>
        <view >
          <ul class="ul-line">
            <li>请不要在楼栋内办公室随意拍照</li>
            <li>携带物品出门必须经过园区电子流审核</li>
            <li>进出门必须对自己识别验证，接受门岗检查</li>
          </ul>
        </view>
      </view>
    </view>

  </view>
</template>

<script>
  import {available} from "../../common/api";

  export default {
    data() {
			return {
        baseList:[
          {name: '/static/image/qyrz.png',title:'企业入驻申请',url: 'pages/company/approval'},
          {name: '/static/image/yqgg.png',title:'园区公告',url: 'pages/announcement/index'},
          {name: '/static/image/fkyy.png',title:'外部访客预约',url: 'pages/accessRecord/index'},
          {name: '/static/image/clyy.png',title:'车辆预约',url: 'pages/vehicle/index'},
        ]
			}
		},
		methods: {
      click(e){
        console.log(e)
        let item = this.baseList[e];
        this.$u.route(item.url);
      }
		}
	}
</script>

<style lang="scss" >
	.content {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
  .top-bg{
    width: 100%;
    text-align: center;
    height: 120px;
    background: #67a8fa;
    color: #ffffff;
  }
  .title{
    font-family: cursive;
    line-height: 72px;
    font-size: 26px;
  }
  .main{
    //height: 200px;
    width: 100%;
    background: white;
    margin-top: -10px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .grid-text {
    font-size: 14px;
    color: #909399;
    padding: 10rpx 0 20rpx 0rpx;
    /* #ifndef APP-PLUS */
    box-sizing: border-box;
    /* #endif */
  }
  .grid-item{
    height: 100px;
    width: 100%;
    text-align: center;
    align-items: center;
    justify-content: center;
    position: relative;
    flex-direction: column;
    box-sizing: border-box;
    display: flex;
  }
  .disflex{
    display: flex;
    align-items: center;
    color: #4c5562;
    font-size: 16px;
  }
  .ul-line{
    font-size: 12px;
    color: #93a0b5;
    li:before {
      content: "";
      width: 6px;
      height: 6px;
      display: inline-block;
      border-radius: 50%;
      background: #7589a3;
      vertical-align: middle;
      margin-right: 22px;
      position: relative;
      top: 50%;
      left: 4%;
      transform: translate(-50%, -50%);
      transition-duration: 0s;
      transition-timing-function: ease;
      transition-delay: 0s;
    }
  }
</style>
